"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_flow_renderer_1 = require("react-flow-renderer");
const pathway_svg_1 = __importDefault(require("../../../assets/images/icons/pathway.svg"));
require("./customNode.scss");
function CustomNode(props) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        props.sourcePosition && (react_1.default.createElement(react_flow_renderer_1.Handle, { type: "source", position: props.sourcePosition })),
        props.targetPosition && (react_1.default.createElement(react_flow_renderer_1.Handle, { type: "target", position: props.targetPosition })),
        react_1.default.createElement("div", { className: "flex-column pathway-cont" },
            react_1.default.createElement("div", { className: "upper-row" },
                react_1.default.createElement("img", { className: "pathway-img", src: props.data.imgSrc || pathway_svg_1.default, alt: "pathway" })),
            react_1.default.createElement("div", { className: "lower-row" },
                react_1.default.createElement("span", { className: "pathway-title" }, props.data.title || "Management Accelerator Program"),
                react_1.default.createElement("span", { className: "pathway-desc" }, props.data.description ||
                    "1 recipient received from this credential")))));
}
exports.default = CustomNode;
